module.exports = __webpack_public_path__ + "img/unzan_c.7a5b0390.svg";